"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("@reach/tooltip/styles.css");
var Styles = _interopRequireWildcard(require("./style"));
var _colors = require("../style/colors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Tooltip extends _react.default.Component {
  constructor(props) {
    super(props);
    this.tooltipWrapper = null;
    this.renderLabel = function (label, hotkey) {
      let customLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return /*#__PURE__*/_react.default.createElement(Styles.LabelWrapper, null, label && ( /*#__PURE__*/_react.default.createElement(Styles.Label, {
        color: _colors.white
      }, /*#__PURE__*/_react.default.createElement(Styles.HotkeyWrapper, null, label, hotkey && ( /*#__PURE__*/_react.default.createElement(Styles.Label, {
        color: _colors.gray,
        isHotkey: true
      }, hotkey))))), customLabel);
    };
    this.setTooltipPosition = this.setTooltipPosition.bind(this);
    this.state = {
      childWidth: 0
    };
  }
  componentDidMount() {
    this.setTooltipPosition();
    window.addEventListener('resize', this.setTooltipPosition);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.setTooltipPosition);
  }
  setTooltipPosition() {
    if (this.tooltipWrapper) {
      const childWidth = this.tooltipWrapper.children[0].children[0].getBoundingClientRect().width;
      this.setState({
        childWidth
      });
    }
  }
  getTooltipPosition(triggerRect, tooltipRect, position, verticalAlign) {
    const {
      childWidth
    } = this.state;
    const gap = 8;
    const triggerCenter = triggerRect.left + childWidth / 2;
    const left = triggerCenter - tooltipRect.width / 2;
    const maxLeft = window.innerWidth - tooltipRect.width - 2;
    const verticalCenter = triggerRect.top + triggerRect.height - (triggerRect.height + tooltipRect.height) / 2 - window.scrollY;
    const verticalTop = triggerRect.top;
    const topPosition = verticalAlign === 'top' ? verticalTop : verticalCenter;
    const newPosition = {
      left: Math.min(Math.max(2, left), maxLeft) + window.scrollX,
      top: triggerRect.bottom + gap + window.scrollY
    };
    switch (position) {
      case 'top':
        newPosition.top = triggerRect.top - tooltipRect.height - gap - window.scrollY;
        break;
      case 'right':
        newPosition.left = triggerRect.left + childWidth + gap + window.scrollX;
        newPosition.top = topPosition;
        break;
      case 'left':
        newPosition.left = triggerRect.left - tooltipRect.width - gap - window.scrollX;
        newPosition.top = topPosition;
        break;
      default:
    }
    return newPosition;
  }
  render() {
    const {
      children,
      label,
      position,
      verticalAlign,
      hotkey,
      customLabel,
      opacity
    } = this.props;
    const renderTooltip = label || customLabel;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderTooltip ? ( /*#__PURE__*/_react.default.createElement(Styles.TooltipWrapper, {
      ref: node => this.tooltipWrapper = node
    }, /*#__PURE__*/_react.default.createElement(Styles.TooltipStyled, {
      label: this.renderLabel(label, hotkey, customLabel),
      position: (triggerRect, tooltipRect) => this.getTooltipPosition(triggerRect, tooltipRect, position, verticalAlign),
      style: Styles.TooltipStyle,
      opacity: opacity
    }, /*#__PURE__*/_react.default.createElement("div", null, children)))) : ( /*#__PURE__*/_react.default.createElement("div", null, children)));
  }
}
Tooltip.propTypes = {
  children: _propTypes.default.node.isRequired,
  label: _propTypes.default.string,
  position: _propTypes.default.string,
  verticalAlign: _propTypes.default.string,
  hotkey: _propTypes.default.string,
  customLabel: _propTypes.default.node,
  opacity: _propTypes.default.number
};
Tooltip.defaultProps = {
  label: '',
  position: 'bottom',
  verticalAlign: 'center',
  hotkey: '',
  customLabel: '',
  opacity: 1
};
var _default = exports.default = Tooltip;